import React from 'react';
import styled from 'styled-components';

import { Container } from '../../../../../../../../assets/elements';
import TypeDelivery from './TypeDelivery';
import device from '../../../../../../../utils/device';

const DeliveryAddress = (props: any) => {
  return (
    <Wrapper>
      <TypeDelivery {...props} />
    </Wrapper>
  );
};

const Wrapper = styled(Container)`
  background: #ffffff;
  border-radius: 8px;
  && {
    padding: 15px;
    @media ${device.tablet} {
      padding: 30px;
    }
  }
  height: auto;
`;

export default DeliveryAddress;
